module.exports = __webpack_public_path__ + "img/icon_map_7_off_111.cb1a2885.png";